import Vue from 'vue';
import VueRouter from 'vue-router';
import createWebHistory from 'vue-router';

import AuthRoutes from '@/modules/auth/routes';
import AppRoutes from '@/router/app.routes';

// middlewares
import {
  checkPermissions,
  checkAuthentication
} from '@/router/middlewares/authentication';

Vue.use(VueRouter);

const routes = [
  {
    path: '',
    name: 'base',
    component: () => import('@/modules/shared/layouts/CoreLayout.vue'),
    redirect: { name: 'auth' },
    children: [...AuthRoutes, ...AppRoutes]
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/modules/shared/views/404.vue'),
    meta: { label: '404' }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: import.meta.env.VITE_BASE_URL,
  routes
});

router.beforeEach(checkAuthentication);
router.beforeEach(checkPermissions);
router.onError((error, to) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed')
  ) {
    window.location.href = to.fullPath;
  }
});
export default router;
